// ======================================================================
// File Name       : ArchivementList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TableHead from '../../components/TableHead';
import * as Path from '../../constants/PathConstants';
import { getItemBoxName } from '../../utils/index';
import ReduxFormPaging from '../ReduxFormPaging';
import CustomLink from '../button/CustomLink';
import * as ICON from '../../constants/IconConstants';
import { SCORING_ARCHIVEMENT_DETAIL } from '../../constants/PathConstants';

class ArchivementList extends React.Component {
  render() {
    const {
      userListInfo,
      reportOperationCountInfo,
      handleSortState,
      goToDetail,
      startPosition,
      recordNum,
      getStartEndData, 
    } = this.props;
    const thead = [
      { title: 'ログインID', sortBy: 1 },
      { title: '添削者', sortBy: 0 },
      { title: '添削レポート件数', sortBy: null, width: '7%' },
      { title: '操作', sortBy: null, width: 130 },
    ];
    const userList =
      userListInfo &&
      userListInfo.map((user, index) => {
        const reportNum = reportOperationCountInfo.bySecernId[user.userSecernId]
          ? reportOperationCountInfo.bySecernId[user.userSecernId].reportNum
          : 0;
        const link = SCORING_ARCHIVEMENT_DETAIL.replace(':id', user.userSecernId);
        return (
          <tr key={user.userSecernId} onMouseEnter={() => this.props.handleMouseEnter(index)} onMouseLeave={() => this.props.handleMouseLeave()}>
            <td>
              {user.loginId}
            </td>
            <td>
              {user.userName}
            </td>
            <td className="text-right" width="200px">
              {reportNum}
            </td>
            <td className="text-center" width="100px">
              <CustomLink
                className="margin-right-7 link-detail"
                to={link}
                text="詳細を見る"
              />
            </td>
          </tr>
        );
      });

    return (
      <div>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="userSortType"
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>
            {userList}
          </tbody>
        </Table>
        <Col className="text-center padding-right-clear margin-bottom-10">
          <ReduxFormPaging
            type="paging"
            name="startPosition"
            recordNum={recordNum}
            getStartEndData={getStartEndData}
          />
        </Col>
      </div>
    );
  }
}

export default ArchivementList;
